import {copy} from '../site.js';
import initCustomSelects, {choicesInstances} from '../select';
import {createCommerceClient} from './commerce-client';
import {CheckoutCoordinator} from './coordinator';
import {StripePayment} from './stripe-payment';
import {checkoutStatus} from './status';

export default function checkoutInteractivity() {
    checkoutStatus();
    const root = document.querySelector('[data-novastars-checkout]');
    const configNode = document.getElementById('novastars-checkout-config');
    if (!root || !configNode) return;
    const scope = root.closest('.checkout') || root.parentElement;
    const form = root.querySelector('.js-edit-delivery-form');
    const billingForm = root.querySelector('.billing-address-form');
    const modal = document.querySelector('.mobile-variant-edit-screen');
    const notice = scope.querySelector('.checkout-notice[role="alert"][hidden]');
    const payment = new StripePayment(root.querySelector('[data-checkout-payment]'));
    let initial = true, coordinator, lastSummary;
    const read = (container, name) => container.querySelector(`[name="${name}"]`)?.value.trim() || '';
    const text = (selector, value) => { const node = root.querySelector(selector); if (node) node.textContent = value || ''; };
    const show = (selector, visible) => { const node = root.querySelector(selector); if (node) node.hidden = !visible; };
    const input = (container, name, value) => {
        const node = container.querySelector(`[name="${name}"]`);
        if (!node) return;
        if (choicesInstances.has(node)) choicesInstances.get(node).setChoiceByValue(String(value || ''));
        else node.value = value || '';
    };
    function addressData() {
        const shipping = {}, billing = {};
        ['company','firstname','lastname','fullname','email','phone','address1','address2','zip','city','state','country'].forEach(key => {
            shipping[key] = read(form, `address[shipping][${key}]`);
            billing[key] = read(billingForm, `address[billing][${key}]`);
        });
        billing.vat = read(billingForm, 'address[billing][properties][vat_registration]');
        return {shipping, billing, billingChoice: root.querySelector('[name="billing-choice"]:checked')?.value || 'same'};
    }
    function displayAddress(data) {
        const s = data.shipping, b = data.billing;
        const values = {'delivery-display .organization':s.company,'delivery-display .address-line1':s.address1,
            'delivery-display .postal-code':s.zip,'delivery-display .locality':s.city,'delivery-display .country':s.country,
            'contact-display .name':`${s.firstname || ''} ${s.lastname || ''}`.trim(),'contact-display .email':s.email,'contact-display .tel':s.phone,
            'billing-address-display .organization':b.company,'billing-address-display .address-line1':b.address1,
            'billing-address-display .postal-code':b.zip,'billing-address-display .locality':b.city,'billing-address-display .country':b.country,
            'billing-address-display .vat-registration':b.vat || b.properties?.vat_registration};
        Object.entries(values).forEach(([selector,value]) => text('.'+selector,value));
    }
    function complete(data) {
        const address = a => ['address1','zip','city','country'].every(key => a[key]);
        return address(data.shipping) && data.shipping.firstname && data.shipping.lastname && data.shipping.email &&
            (data.billingChoice === 'same' || address(data.billing));
    }
    function validateEditor(container) {
        let first;
        container.querySelectorAll('input.required:not([type="hidden"]), select.required').forEach(node => {
            const invalid = !node.value.trim() || (node.type === 'email' && !node.validity.valid);
            node.setAttribute('aria-invalid', String(invalid)); node.closest('.field')?.classList.toggle('error', invalid);
            if (invalid && !first) first = node;
        });
        if (first) { first.focus(); view.message('Please complete the required fields with valid details.', true); return false; }
        return true;
    }
    function destroySelects(container) {
        container?.querySelectorAll('select').forEach(select => { choicesInstances.get(select)?.destroy(); choicesInstances.delete(select); });
    }
    const view = {
        finish(url) { window.location.assign(url); },
        message(message, error = false) {
            message = copy(message);
            if (error) payment.stopLoading(message);
            notice.querySelector('[data-notice-text]').textContent = message;
            notice.hidden = !message;
            notice.classList.toggle('is-error', error);
        },
        busy(busy) {
            root.setAttribute('aria-busy', String(busy));
            scope.querySelectorAll('button, .cart-item .quantity-input, .cart-item .variant-select').forEach(node => { node.disabled = busy; });
            root.querySelector('.button-buy').disabled = busy || !coordinator?.state?.order?.items?.length || coordinator?.state?.stockAvailable === false;
        },
        render(state) {
            const old = document.querySelector('.checkout-summary');
            if (old && state.summary && state.summary !== lastSummary) {
                const open = !!old.querySelector('.accordion-item.is-active');
                const editing = old.querySelector('.cart-item.is-editing')?.dataset.itemId;
                destroySelects(old); old.outerHTML = state.summary;
                const next = document.querySelector('.checkout-summary');
                if (editing) next.querySelectorAll(`[data-item-id="${editing}"]`).forEach(item => item.classList.add('is-editing'));
                window.jQuery(next).find('[data-accordion]').foundation();
                if (open) {
                    const accordion = window.jQuery(next).find('[data-accordion]');
                    accordion.foundation('down', accordion.find('.accordion-content').first());
                }
                initCustomSelects();
                lastSummary = state.summary;
            }
            if (state.stockAvailable === false) view.message(Object.values(state.stockErrors || {}).join(' '), true);
            if (initial) {
                ['shipping', 'billing'].forEach(type => {
                    const container = type === 'shipping' ? form : billingForm;
                    Object.entries(state[type] || {}).forEach(([key,value]) => { if (typeof value === 'string') input(container, `address[${type}][${key}]`, value); });
                });
                input(billingForm, 'address[billing][properties][vat_registration]', state.billing.properties?.vat_registration || '');
                const choice = root.querySelector(`[name="billing-choice"][value="${state.billingChoice}"]`);
                if (choice) choice.checked = true;
                updateBillingChoice(false); displayAddress({shipping:state.shipping,billing:state.billing}); initial = false;
            }
        }
    };
    coordinator = new CheckoutCoordinator({request:createCommerceClient(JSON.parse(configNode.textContent)), view,
        payment});
    const perform = promise => promise.catch(() => {});
    function updateBillingChoice(edit = true) {
        const different = addressData().billingChoice === 'new';
        show('.billing-address-form', different && edit); show('.billing-address-display', different && !edit);
        root.querySelectorAll('[name="billing-choice"]').forEach(node => node.closest('.custom-radio').classList.toggle('is-checked', node.checked));
    }
    async function saveEditor(type) {
        const editor = type === 'billing' ? billingForm : root.querySelector(`.${type}-form`);
        if (!validateEditor(editor)) return;
        const data = addressData();
        if (complete(data)) await coordinator.mutate('address', data);
        else view.message(copy('Complete your delivery address and contact details before paying.'));
        displayAddress(data);
        if (type === 'billing') { show('.billing-address-form', false); show('.billing-address-display', true); }
        else { show(`.${type}-form`, false); show(`.${type}-display`, true); }
        root.querySelector('.saved-address').classList.toggle('display', root.querySelector('.delivery-form').hidden && root.querySelector('.contact-form').hidden);
    }
    function selectedProduct(container, fallback) {
        const row = container.querySelector('select[name="new_row"]')?.value;
        const col = container.querySelector('select[name="new_column"]')?.value;
        if (!row && !col) return Number(fallback);
        const option = [...container.querySelectorAll('.matrix-option')].find(node => (!row || node.dataset.row === row) && (!col || node.dataset.column === col));
        if (!option) throw new Error('This variant is unavailable.');
        return Number(option.dataset.productId || option.value);
    }
    function closeModal() { document.body.classList.remove('modal-open'); }
    function openModal(item) {
        modal.dataset.currentEditId = item.dataset.itemId;
        modal.dataset.product = coordinator.state.order.items.find(row => row.id == item.dataset.itemId)?.product;
        modal.querySelector('.product-info img').src = item.querySelector('figure img').src;
        modal.querySelector('.product-info .name').textContent = item.querySelector('.item-title').textContent;
        modal.querySelector('.product-info .variant').textContent = item.querySelector('.options-mobile').textContent;
        modal.querySelector('.product-info .price').textContent = item.querySelector('.cart-item-price').textContent;
        modal.querySelector('.quantity-input').value = item.querySelector('.quantity-input').value;
        destroySelects(modal);
        ['column','row'].forEach(axis => {
            const target = modal.querySelector(`.${axis}-variant`);
            const original = item.querySelector(`.options-desktop-${axis} select`);
            target.replaceChildren();
            if (original) {
                const clone = original.cloneNode(true);
                clone.removeAttribute('hidden'); clone.removeAttribute('data-choice'); clone.removeAttribute('tabindex');
                clone.className = 'variant-select-mobile js-select'; clone.value = original.value; target.append(clone);
            }
        });
        const matrix = modal.querySelector('.matrix-options-container'); matrix.replaceChildren();
        item.querySelectorAll('.matrix-options').forEach(node => matrix.append(node.cloneNode(true)));
        initCustomSelects(); document.body.classList.add('modal-open');
    }
    scope.addEventListener('click', event => {
        const button = event.target.closest('button, .save-product-variant-mobile, .mobile-edit-overlay');
        if (!button) return;
        if (coordinator.pending) { event.preventDefault(); return; }
        const item = button.closest('.cart-item'), stop = () => event.preventDefault();
        if (button.matches('.js-edit')) {
            stop(); const type = button.closest('[data-this]').dataset.this;
            show(`.${type}-display`, false); show(`.${type}-form`, true);
        } else if (button.matches('.js-save')) { stop(); perform(saveEditor(button.closest('[data-this]').dataset.this)); }
        else if (button.matches('.save-billing-address')) { stop(); perform(saveEditor('billing')); }
        else if (button.matches('.js-edit-billing')) { stop(); updateBillingChoice(true); }
        else if (button.matches('.remove-cart-item')) { stop(); perform(coordinator.mutate('remove', {item:Number(item.dataset.itemId)})); }
        else if (button.matches('.add-complete-item')) {
            stop();
            try { perform(coordinator.mutate('add', {product:selectedProduct(button.closest('.complete-item'), button.value),quantity:1})); }
            catch (error) { view.message(error.message, true); }
        } else if (button.matches('.edit-cart-item-desktop')) { stop(); item.classList.toggle('is-editing'); }
        else if (button.matches('.edit-cart-item')) { stop(); openModal(item); }
        else if (button.matches('.quantity-btn')) {
            stop(); const field = button.closest('.quantity-selector-input').querySelector('.quantity-input');
            field.value = Math.max(0, Number(field.value) + (button.dataset.action === 'increase' ? 1 : -1));
            field.dispatchEvent(new Event('change', {bubbles:true}));
        } else if (button.matches('.mobile-edit-overlay')) { stop(); closeModal(); }
        else if (button.matches('.save-product-variant-mobile')) {
            stop();
            try {
                const quantity = Number(modal.querySelector('.quantity-input').value), product = selectedProduct(modal, modal.dataset.product);
                perform(coordinator.mutate(quantity === 0 ? 'remove' : 'variant', {item:Number(modal.dataset.currentEditId),product,quantity}).then(closeModal));
            } catch (error) { view.message(error.message, true); }
        }
    });
    scope.addEventListener('change', event => {
        const field = event.target;
        if (coordinator.pending) return;
        if (field.matches('[name="billing-choice"]')) {
            updateBillingChoice();
            if (field.value === 'same' && complete(addressData())) perform(coordinator.mutate('address', addressData()));
        }
        const item = field.closest('.cart-item');
        if (item && field.matches('.quantity-input')) perform(coordinator.mutate('quantity', {item:Number(item.dataset.itemId),quantity:Number(field.value)}));
        if (item && field.matches('.variant-select')) {
            try { perform(coordinator.mutate('variant', {item:Number(item.dataset.itemId),product:selectedProduct(item),quantity:Number(item.querySelector('.quantity-input').value)})); }
            catch (error) { view.message(error.message, true); }
        }
    });
    root.querySelector('.payment-form').addEventListener('submit', event => {
        event.preventDefault();
        if (coordinator.pending) return;
        // The fullname hidden field is populated from first and last name on the server.
        form.querySelector('[name="address[shipping][fullname]"]').value = `${read(form,'address[shipping][firstname]')} ${read(form,'address[shipping][lastname]')}`.trim();
        if (!validateEditor(form) || (addressData().billingChoice === 'new' && !validateEditor(billingForm))) return;
        const payButton = root.querySelector('.button-buy');
        const loading = value => {
            payButton.setAttribute('aria-busy', String(value));
            payButton.querySelector('.checkout-button-spinner').hidden = !value;
            payButton.querySelector('[data-payment-label]').textContent = copy(value ? 'Processing payment…' : 'Pay now');
        };
        loading(true);
        perform(coordinator.pay(addressData()).finally(() => loading(false)));
    });
    form.addEventListener('submit', event => { event.preventDefault(); if (!coordinator.pending && complete(addressData())) perform(coordinator.mutate('address', addressData())); });
    scope.addEventListener('submit', event => {
        if (event.target.matches('.cart-items-form, .complete-order-form')) event.preventDefault();
    });
    root.querySelector('.payment-form').noValidate = true;
    perform(coordinator.load());
}
